

import VesselMonitoringBay from '@/view/pages/vesselMonitoring/components/FullScreenHatchsView/VesselMonitoringBay.vue'
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    VesselMonitoringBay
  },
  props: {
    vesselHatch: { type: Object as () => any, default: () => ({ vesselBays: [],hatchCovers:{} }) },
    minDeckTiersNo:{default: 0},
    minHoldTiersNo:{default: 0},
    maxRows:{default:0},
    cellWidth: { default: null }
  },
  mounted() {
  },
  methods: {
    selectedBay(value){ 
    this.$emit('selectedBay', value);
}

  },
  computed: {
    ...mapGetters(["getVesselMonitoringData"]),
    
    vesselMonitoringData() {
      return this.getVesselMonitoringData;
    }
  },
}
